import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H3 from 'UIComponents/elements/headings/H3';
import HR from 'UIComponents/elements/HR';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { MINIMUM_SEARCH_LENGTH, NEWEST, RELEVANCE, SEARCH_KEY, SORT_KEY } from '../constants/ReviewsListQueries';
export default function ReviewsHeader({
  onUpdateFilters,
  renderedButtonRow = null,
  renderedInlineActions = null,
  reviewsCount,
  reviewFilters,
  showDivider = true
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderedButtonRow, /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        role: "tooltip",
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "marketplace-ui-reviews.list.tooltip"
        }),
        children: /*#__PURE__*/_jsx(H3, {
          "aria-level": 3,
          className: "m-bottom-0 is--heading-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.list.header",
            options: {
              count: reviewsCount
            }
          })
        })
      }), /*#__PURE__*/_jsxs(UIFlex, {
        justify: "end",
        align: "center",
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          "aria-label": I18n.text('marketplace-ui-reviews.list.search'),
          children: /*#__PURE__*/_jsx(UISearchInput, {
            value: reviewFilters.get('search'),
            onChange: event => {
              const value = event.target.value; // Apply relevance sort when search term is initially entered

              if (reviewFilters.search.length < MINIMUM_SEARCH_LENGTH && value.length >= MINIMUM_SEARCH_LENGTH) {
                onUpdateFilters({
                  textKey: SORT_KEY,
                  value: RELEVANCE
                });
              } // Apply default sort if sorting by relevance when search term removed


              if (value.length < MINIMUM_SEARCH_LENGTH && reviewFilters.sort === RELEVANCE) {
                onUpdateFilters({
                  textKey: SORT_KEY,
                  value: NEWEST
                });
              }

              onUpdateFilters({
                textKey: SEARCH_KEY,
                value
              });
            }
          })
        }), renderedInlineActions && /*#__PURE__*/_jsx("span", {
          className: "m-left-2",
          children: renderedInlineActions
        })]
      })]
    }), showDivider && /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    })]
  });
}